export default {
  'forgetpassword.forgetpassword': 'Забыли пароль? ',
  'forgetpassword.wrongemail': 'E- mail не является действительным',
  'forgetpassword.resetemail':
    'забыл пароль.переустановить почту Введите свой адрес электронной почты для восстановления пароля',
  'forgetpassword.resetpassword': 'переустановка пароля',
};
